import cloneDeep from 'lodash/cloneDeep';
import { observable } from 'mobx';

import { FIRST_TAB } from './broadcastNew/constants';

import { DeepSearchService } from '../userManager';

class BroadcastStore {
  constructor() {
    this.resetNewBroadcast();
    DeepSearchService.clearFiltersByCallback();
  }

  cleanNewBroadcast = {
    currentTab: FIRST_TAB,
    name: '',
    message: '',
    sentToAllUsers: false,
    filters: [],
    usersLength: 0
  };

  @observable listBroadcast = {
    content: [],
    pagination: {
      numberOfElements: 0,
      page: 0,
      perPage: 10,
      totalElements: 0
    }
  };

  @observable newBroadcast = {};

  @observable isDeepSearchValid = true;

  resetNewBroadcast = () => {
    this.newBroadcast = cloneDeep(this.cleanNewBroadcast);
  };
}

export default new BroadcastStore();
